<div class="page-container">
  <div class="page-header">
    <div class="page-header-left">
      <h2 class="page-title">Sent Correspondence</h2>
      <p class="page-subtitle">History of all sent and scheduled correspondence.</p>
    </div>
    <button mat-flat-button color="primary" [routerLink]="['/app/correspondence/compose']">
      <mat-icon>add</mat-icon>
      Compose
    </button>
  </div>

  <!-- Filter Bar -->
  <div class="filter-bar">
    <mat-form-field appearance="outline" class="filter-status">
      <mat-label>Status</mat-label>
      <mat-select [(ngModel)]="filterStatus" (ngModelChange)="onFilter()">
        <mat-option value="">All</mat-option>
        @for (s of statuses; track s) {
          <mat-option [value]="s">{{ s | titlecase }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-date">
      <mat-label>Date Range</mat-label>
      <mat-date-range-input [rangePicker]="rangePicker">
        <input [(ngModel)]="filterStart" (ngModelChange)="onFilter()" matStartDate placeholder="Start">
        <input [(ngModel)]="filterEnd" (ngModelChange)="onFilter()" matEndDate placeholder="End">
      </mat-date-range-input>
      <mat-datepicker-toggle matIconSuffix [for]="rangePicker"></mat-datepicker-toggle>
      <mat-date-range-picker #rangePicker></mat-date-range-picker>
    </mat-form-field>

    @if (filterStatus || filterStart || filterEnd) {
      <button mat-stroked-button (click)="clearFilters()">
        <mat-icon>filter_list_off</mat-icon>
        Clear Filters
      </button>
    }
  </div>

  <!-- Table -->
  <div class="mat-elevation-z2 table-wrapper">
    <table mat-table [dataSource]="dataSource" matSort aria-label="Sent correspondence">

      <!-- Date Column -->
      <ng-container matColumnDef="sentDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
        <td mat-cell *matCellDef="let row">{{ (row.sentAt ?? row.scheduledAt ?? row.createdAt) | date:'MM/dd/yyyy h:mm a' }}</td>
      </ng-container>

      <!-- Template Column -->
      <ng-container matColumnDef="templateName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Message</th>
        <td mat-cell *matCellDef="let row">
          <div class="template-cell">
            <mat-icon class="template-icon">description</mat-icon>
            <div>
              <div>{{ row.subject }}</div>
              <small class="muted">{{ row.templateName ? 'Template: ' + row.templateName : 'Ad-hoc' }} · {{ row.createdBy || 'System' }}</small>
            </div>
          </div>
        </td>
      </ng-container>

      <!-- Audience Column -->
      <ng-container matColumnDef="audience">
        <th mat-header-cell *matHeaderCellDef>Audience</th>
        <td mat-cell *matCellDef="let row"><span class="muted">{{ row.audience }}</span></td>
      </ng-container>

      <!-- Recipients Column -->
      <ng-container matColumnDef="recipients">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Recipients</th>
        <td mat-cell *matCellDef="let row">
          <div class="recipients-cell">
            <mat-icon>group</mat-icon>
            {{ row.recipientCount | number }}
            <small class="muted" *ngIf="row.status === 'SENT' || row.status === 'FAILED'">({{ row.sentCount }} e-mailed<ng-container *ngIf="row.failedCount">, {{ row.failedCount }} no e-mail/failed</ng-container>)</small>
          </div>
        </td>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
        <td mat-cell *matCellDef="let row">
          <span class="status-badge" [ngClass]="getStatusClass(row.status)" [title]="row.error || ''">
            {{ row.status | titlecase }}
          </span>
          <small class="muted" *ngIf="row.status === 'SCHEDULED'"><br>{{ row.scheduledAt | date:'MM/dd/yyyy h:mm a' }}</small>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">
          <mat-icon>mail_outline</mat-icon>
          <span>No correspondence records found.</span>
        </td>
      </tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 25, 50]" showFirstLastButtons></mat-paginator>
  </div>
</div>
